// extracted by mini-css-extract-plugin
export default {"tableHeader":"l5xzL29WR3aOiXFXNUF1","infoCell":"fysRDShpjhhhOUR4GCWV"};